<template>
  <div id="product-list-container-id" :class="{'is-loading': isLoading}">
<!--    PC端内容-->
    <div class="productList">
      <div class="banner" id="banner" @mouseenter="bannerSwiperMouseenter" @mouseleave="bannerSwiperMouseleave">
        <swiper :options="bannerSwiper" ref="bannerSwiperRef">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in filterBillboard(this.billboards, $i18n.locale)" data-index="index"
                        :key="index">
            <div v-if="item.URL"><a style="cursor: pointer" @click="onClickBillboard(item.URL, item.MIMEType)"><img
              class='swiImg' :src='item.Image'/></a></div>
            <div v-else><img class='swiImg' :src='item.Image'/></div>
          </swiper-slide>
        </swiper>
        <div class="banner-button-prev">
          <font-awesome-icon icon="chevron-left" :style="{ color: 'black', fontSize: '20px', marginRight: '10px' }"/>
        </div>
        <div class="banner-button-next">
          <font-awesome-icon icon="chevron-right" :style="{ color: 'black', fontSize: '20px', marginLeft: '10px'  }"/>
        </div>
      </div>


      <div class="category-buttons" id="category-buttons">
        <ul>
          <li v-for="(item, index) in allGroups" :key="index">
            <div class="group-button-container">
              <div class="image-placeholder" @click="selectNewGroup(item)">
                <img class="button-image" :src="item.Image" alt="">
              </div>
              <p class="group-button-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="product-listing-container">
        <div class="product-list-container">
          <aside class="desktop-category-menu" aria-label="Product categories">
            <ul class="desktop-category-menu__groups">
              <li class="desktop-category-menu__group">
                <button
                  type="button"
                  class="desktop-category-menu__group-button"
                  :class="{ 'is-active': isAllProductsSelected }"
                  :aria-pressed="isAllProductsSelected"
                  @click="selectAllProducts">
                  <span>{{ curIsEnglish ? 'All Products' : $t('all') }}</span>
                </button>
              </li>
              <li
                v-for="(group, groupIndex) in allGroups"
                :key="'desktop-category-group-' + groupIndex"
                class="desktop-category-menu__group">
                <button
                  type="button"
                  class="desktop-category-menu__group-button"
                  :class="{ 'is-active': selectedGroupLocal.includes(group.Name) }"
                  @click="toggleDesktopGroup(group)">
                  <span>{{ curIsEnglish ? group.Name : group.Description }}</span>
                  <span
                    v-if="group.Categories && group.Categories.length"
                    class="desktop-category-menu__chevron"
                    :class="{ 'is-open': desktopExpandedGroups.includes(group.Name) }"
                    aria-hidden="true">
                  </span>
                </button>
                <ul
                  v-if="desktopExpandedGroups.includes(group.Name) && group.Categories && group.Categories.length"
                  class="desktop-category-menu__categories">
                  <li
                    v-for="category in group.Categories"
                    :key="'desktop-category-' + category.ProductCategory_id">
                    <button
                      type="button"
                      class="desktop-category-menu__category-button"
                      :class="{ 'is-active': allGroups_Categories_ids.includes(category.ProductCategory_id) }"
                      @click="selectNewCategory(category, true)">
                      {{ curIsEnglish ? category.Name : category.Description }}
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </aside>
          <div class="products">
            <div class="products_div" id="products_div">
              <div class="breadcrumb-container">
                <div class="breadcrumb-fill"></div>
                <img class="bread-img"
                    :style="{cursor: 'pointer'}"
                    src="../assets/img/breadcrumb-home.png"
                    @click="$router.push('/home')">
                <el-breadcrumb class="breadcrumb-products" separator=">">
                  <el-breadcrumb-item>
                    <a class="bread-text">{{ $t('products') }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeGroupEn && curIsEnglish">
                    <a class="bread-text">{{ activeGroupEn }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeGroupCh && curIsChinese">
                    <a class="bread-text">{{ activeGroupCh }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeCategoryEn && curIsEnglish">
                    <a class="bread-text">{{ activeCategoryEn }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeCategoryCh && curIsChinese">
                    <a class="bread-text">{{ activeCategoryCh }}</a>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="is-stockLevel">
                <el-checkbox v-model="stockLevelChecked" @change="isSockLevel">{{$t('in_stock')}}</el-checkbox>
              </div>
              <div class="product-list-actions">
                <div class="sort-by-filter">
                  <span>{{ $t('sortBy') }} :</span>
                  <afmSelect
                    v-model="sortByFilter"
                    @change="adjustPriceSort"
                    :optionList="sortByOptions"
                    :hoverIsShow="true"
                    :placeholder="$t('pleaseSelectSortingMethod')">
                  </afmSelect>
                </div>
                <div class="product-list-actions__buttons">
                  <el-button
                    :loading="isPrinting"
                    @click="printProducts">
                    {{ $t('print') }}
                  </el-button>
                  <el-button
                    :loading="isExporting"
                    @click="exportProducts">
                    {{ $t ('Export') }}
                  </el-button>
                </div>
              </div>
            </div>
            <ul v-if="!isLoading">
              <li
                v-for="(item, index) in showList"
                v-bind:key="index"
                :class="{'list-view': !currentViewIsGallery}"
                v-if="!item.IsStopSale && (showMore || index<9)">
                <!-- {{item}} -->
                <productCard
                  ref="productCardRef"
                  @imgLoad="imgLoad"
                  @imgAbort="imgAbort"
                  v-show="currentViewIsGallery"
                  v-bind:img="item.ThumbnailLarge"
                  v-bind:link="item.link"
                  v-bind:brand="item.Brand"
                  v-bind:rating="item.Rating"
                  v-bind:name="item.Name"
                  v-bind:description="item.Description"
                  v-bind:isPromotion="item.IsPromotion"
                  v-bind:price="item.Price"
                  v-bind:item="item"
                  v-bind:inCart="inCart"
                  v-bind:quantity="item.Quantity"
                  v-bind:key="index"
                  v-bind:refNum="item.RefNum"
                  v-bind:productNum="item.ProductNum"
                  v-bind:packageSize="item.PackageSize"
                  v-bind:hidePrice="true"
                ></productCard>
<!--                因为样的层级问题比较复杂，所以一个一个判断吧-->
                <div v-show="!currentViewIsGallery" class="list-container-1">
                  <buy-one-get-one
                    v-if="item.BuyAGetB_promotion"
                    v-bind:fromQty="item.BuyAGetB_FromQty"
                    v-bind:relatedQty="item.BuyAGetB_RelatedQty"
                  ></buy-one-get-one>
                  <!-- <img :src="item.Thumbnail" alt="" @click="goToProductDetail(item)"> -->
                  <img
                    :src="item.Thumbnail || defaultProductImage"
                    :class="{ 'is-fallback-logo': !item.Thumbnail }"
                    alt=""
                    @error="useDefaultProductImage">
                </div>
                <div v-show="!currentViewIsGallery" class="list-container-2">
                  <p class="list-brand" @click="selectNewSearch(item.Brand, 'Brand')">{{ item.Brand }}</p>
                  <p class="list-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
                  <div class="list-star-container">
                    <img v-for="(item2,index) in getStarIndex(item.Rating)"
                         :data-index="index"
                         :key="index"
                         class="list-star-img"
                         :src="item2" alt="">
                    <p class="list-star-text">{{ item.Rating }}</p>
                  </div>
                </div>
                <div v-show="!currentViewIsGallery" class="list-container-4">
                  <button v-if="isOutOfStock(item)" class="ajax_addto_cart_btn">{{ $t('outOfStock') }}</button>
                  <button
                    v-else
                    class="ajax_addto_cart_btn"
                    @click="throttleAddToCart(item, $event)"
                  >
                    {{ $t('addToCart') }}
                  </button>
                </div>
              </li>
            </ul>
            <div v-else class="loadingWindow">
              <img src="../assets/img/loading.gif" alt="">
            </div>
            <div class="show-more-container" v-if="isShowShowMoreContent">
              <button id="product-show-more-button" class="show-more-button" @click="clickShowMore()">{{ $t('showMore') }}</button>
            </div>
          </div>
        </div>
      </div>

      <pcRecommended class="recommended-outer-container" id="pcRecommended" :isShowButton="false" :inCart="inCart"></pcRecommended>


    </div>
<!--    手机端内容-->
    <div class="MbproductList botPage collections-mobile-refresh">
      <mbHeader :title="$t('products')" :left="true" :showCompany="true" @searchProduct="searchProduct" @selectNewGroup="selectNewGroup">
        <button class="collections-locale" type="button" @click.stop="langChanged">中文 / EN</button>
      </mbHeader>

      <div class="collections-mobile-sticky">
        <div class="searchFor">
          <div class="searchBox">
            <input type="text" :placeholder="$t('search_for')" v-model="searchTerm" @keypress.enter="searchProduct">
            <div class="glass">
              <font-awesome-icon icon="search" @click="searchProduct"/>
            </div>
          </div>
        </div>

        <div class="category-filter-row">
          <div
            class="category-subclass-buttons"
            id="fixedRef">
            <ul class="allGroups_Categories">
              <li
                v-for="item in allGroups"
                :key="item.ProductGroup_id"
                @click="selectNewGroup(item)"
                :class="{active:selectedGroupLocal.includes(item.Name)}">
                <p class="group-button-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
              </li>
            </ul>
          </div>
          <button class="showClass" type="button" aria-label="Filter products" @click="showppoducts=!showppoducts">
            <img src="../assets/img/category2.png" alt="" v-if="!showppoducts">
            <img src="../assets/img/category1.png" alt="" v-else>
          </button>
        </div>
      </div>

      <div
        class="products"
        :class="{vertical:true}">
        <ul v-if="!isLoading">
          <li
            v-for="(item, index) in showList"
            v-bind:key="index"
            v-if="!item.IsStopSale && (showMore || index<9)">
            <buy-one-get-one
              v-if="item.BuyAGetB_promotion"
              v-bind:fromQty="item.BuyAGetB_FromQty"
              v-bind:relatedQty="item.BuyAGetB_RelatedQty"
            ></buy-one-get-one>
            <div class="left">
              <img
                v-lazy="item.Thumbnail || defaultProductImage"
                :key="item.Thumbnail || defaultProductImage"
                :src="item.Thumbnail || defaultProductImage"
                :class="{ 'is-fallback-logo': !item.Thumbnail }"
                :alt="item.Name"
                @error="useDefaultProductImage"
                @click="goToProductDetail(item)"
              >
            </div>
            <div class="min" @click="goToProductDetail(item)">
              <p class="refNum-name">{{item.RefNum}}</p>
              <p class="list-brand">{{curIsEnglish ? item.Name : item.Description}}</p>
              <p class="package-size">{{item.PackageSize}}</p>
            </div>
          </li>
        </ul>
        <div v-else class="loadings">
          <img src="../assets/img/loading.gif" alt="">
        </div>
        <div class="show-more-container" v-if="isShowShowMoreContent">
          <button id="product-show-more-button" class="show-more-button" @click="clickShowMore()">{{ $t('showMore') }}</button>
        </div>
        <!--        <div class="nodeData" style="display: none" v-if="list.length<=0 && !isLoading">{{ $t('noMoreProducts') }}</div>-->
      </div>

      <recommended v-if="!isLoading"></recommended>

<!--      选择分类弹框-->
      <div class="popupbt allProducts" :class="{showpop:showppoducts}">
        <div class="model-pop" @click="showppoducts = !showppoducts" @touchmove.prevent></div>
        <div class="pop-content">
          <div class="close" @click="showppoducts = !showppoducts">
            <img src="../assets/img/close.png" alt="">
          </div>
          <div class="category-filter">

            <div>
              <div class="filter_header">
                <p class="category-title" @click="toggleGroups">{{ $t('categories') }}</p>
                <font-awesome-icon
                  icon="chevron-up"
                  @click="toggleGroups"
                  :class="groupsOpen ? 'rotate' : 'rotate-back'"/>
              </div>
              <el-checkbox-group
                v-for="(item,index) in allGroups"
                :key="index"
                v-model="selectedGroupLocal"
                v-show="groupsOpen"
                @change="selectNewGroup(item),showppoducts = false">
                <el-checkbox :label="item.Name">{{ curIsEnglish ? item.Name : item.Description }}</el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="mobile-filter-block mobile-sort-filter">
              <div class="filter_header">
                <p class="category-title" @click="toggleSort">{{ $t('sortBy') }}</p>
                <font-awesome-icon
                  icon="chevron-up"
                  @click="toggleSort"
                  :class="sortOpen ? 'rotate' : 'rotate-back'"/>
              </div>
              <div
                class="mobile-sort-options"
                v-show="sortOpen">
                <el-checkbox
                  v-for="item in sortByOptions"
                  :key="'mobile-sort-' + item.value"
                  :value="sortByFilter === item.value"
                  @change="handleMobileSortChange(item.value)">
                  {{ curIsEnglish ? item.label_en : item.label_ch }}
                </el-checkbox>
              </div>
            </div>

            <div class="mobile-filter-block mobile-stock-filter">
              <div class="filter_header">
                <el-checkbox v-model="stockLevelChecked" @change="handleMobileStockChange">
                  {{ $t('in_stock') }}
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="images-modal-mask" v-if="imagesVisible" @click.self="closeImages">
        <div class="images">
          <img :src="images" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import {responseList} from '@/api/response_list';
import {exportFile} from '@/common/exportFile';
import {printPdf} from '@/common/printPdf';

// import breadcrumb from "@/components/breadcrumb";
import Utils from "../assets/js/util";
import busUtil from "../assets/js/util";
import productCard from "./productCard";
import mbHeader from "../components/mobile/mbHeader";
import buyOneGetOne from "../components/buy-one-get-one/buy-one-get-one";
import star0 from '../assets/img/star0.jpg'
import star1 from '../assets/img/star1.jpg'
import star2 from '../assets/img/star2.jpg'
import {isUserAuthenticated} from "../store/modules/cart";
import recommended from "./recommended";
import afmSelect from "../components/afm-select/afm-select";
import pcRecommended from "../components/pc-recommended/pc-recommended";
import {locales, outOfStockSorts, toProductDetail, uni} from "../mixin";
import defaultProductImage from '../assets/img/afm-logo.png';

const SELECT_NEW_GROUP = 'selectNewGroup'
const SELECT_NEW_CUSTOM_CATEGORY  = 'selectNewCustomCategory'
const ALL_GROUPS_CATEGORIES_SELECT  = 'allGroupsCategoriesSelect'
const GALLERY  = 'gallery'
const SEARCH_NAME  = 'searchName'
const defaultIsPage = true

export default {
  name: "productList",
  mixins: [outOfStockSorts, locales, toProductDetail, uni],
  components: {
    // breadcrumb,
    productCard,
    mbHeader,
    recommended,
    afmSelect,
    pcRecommended,
    'buy-one-get-one': buyOneGetOne
  },
  data() {
    return {
      showppoducts: false,
      defaultProductImage,
      viewSwitch: false,
      isLoading: true,
      isPrinting: false,
      isExporting: false,
      productExportRequest: null,
      // path2: this.currentGroup,
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      chgroup: '',
      sonNavList: [],
      option: "",//下拉框选项值
      sortByFilter: '1',
      sortByOptions: [{
        value: '1',
        label_en: 'Default',
        label_ch: '默認'
      }, {
        value: '2',
        label_en: 'Name',
        label_ch: '品名'
      }],
      list: [],
      listReg: [],
      listOut: [],
      catReg: [],
      catOut: [],
      inCart: null,
      isAllProductsSelected: false,
      activeGroupEn: '',
      activeGroupCh: '',
      activeCategoryEn: '',
      activeCategoryCh: '',
      filter: '',
      groupsOpen: true,
      customCategoriesOpen: true,
      brandOpen: true,
      priceOpen: true,
      sortOpen: true,
      selectedGroupLocal: [],
      desktopExpandedGroups: [],
      selectedCustomCategoryLocal: [],
      priceFilter: 51,
      priceFilterDisplay: '',
      // currentGroupId: '',
      brandFilter: [],
      brandFilterOptions: [],
      showMore: true,
      searchType: '',
      searchBrand: '',
      currentView: GALLERY,// 当前展示的商品的样式
      currentGroupCategories: [],

      searchTerm: "",
      allGroups_Categories: [],
      allGroups_Categories_id: null,
      reqProductsWithCustomCategoryData: [],
      allGroups_Categories_ids: [],
      isFixed: false,
      curSelectNewCategoryItem: null,
      pageInfo: {
        pageSize: 100,
        pageNum: 1,
        total: 0
      },
      // 是否分页
      isPage: defaultIsPage,
      //是否显示有库存
      stockLevelChecked: false,
      //备份的产品数据
      list2: [],
      //商品图片的弹窗
      imagesVisible: false,
      images: ''
    }
  },
  methods: {
    useDefaultProductImage(event) {
      const image = event.currentTarget
      if (!image || image.dataset.fallbackApplied === 'true') return
      image.dataset.fallbackApplied = 'true'
      image.src = defaultProductImage
      image.classList.add('is-fallback-logo')
    },
    ...mapActions('products', ['fetchCategories', 'fetchProductsWithGroupId', 'fetchProductsWithGroupAll', 'fetchProductsWithCustomCategoryId', 'fetchBrands']),
    ...mapMutations('products', ['updateSelectedGroupGlobal', 'updateSelectedCustomCategoryGlobal', 'updateSelectedCategoryGlobal', 'updateSelectedSearchGlobal']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapActions('search', ['fetchProducts']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    ...mapActions(['changeNavGoId','changeShowProductsType1','changeShowProductsType2','changeShowProductsType3','changeShowList']),
    allGroupsCategoriesSelect(item, isMultiple){
      let ids = item.ProductCategory_id
      if (ids && !isMultiple) {
        const idx = this.allGroups_Categories_ids.indexOf(ids)
        if (idx > -1) {
          this.allGroups_Categories_ids.splice(idx, 1)
        } else {
          this.allGroups_Categories_ids.push(ids)
        }
        this.setLocalAllGroupsCategoriesIds();
        isMultiple = true
      }
      this.allGroups_Categories_id = ids
      if (isMultiple) {
        ids = this.allGroups_Categories_ids.join(',')
        this.allGroups_Categories_id = this.allGroups_Categories_ids[0]
      }
      if (!ids) {// 没有选择二级分类，查询父级数据
        const groupSelect0 = this.selectedGroupLocal[0]
        if (!groupSelect0) {
          return;
        }
        const resItem = this.allGroups.find(item => item.Name === groupSelect0)
        resItem && this.selectNewGroup(resItem)
        return
      }
      // 选择了二级分类
      this.setLocalAllGroupsCategoriesIds();
      const selectGroupsCategories = this.allGroups_Categories.filter(item => this.allGroups_Categories_ids.includes(item.ProductCategory_id))
      if (selectGroupsCategories.length) {
        let activeCategoryEnList = []
        let activeCategoryChList = []
        selectGroupsCategories.forEach(item => {
          const {Name, Description} = item;
          activeCategoryEnList.push(Name);
          activeCategoryChList.push(Description)
        })
        this.activeCategoryEn = activeCategoryEnList.join(',');
        this.activeCategoryCh = activeCategoryChList.join('，');
      }
      this.fetchSelectedCategories(ids)
    },
    initializeSelection(isActivated = false, isAllGroupsCategories = false) {
      this.isLoading = true;
      const param1 = JSON.parse(localStorage.getItem(SELECT_NEW_GROUP))
      const param3 = JSON.parse(localStorage.getItem(ALL_GROUPS_CATEGORIES_SELECT))
      const param4 = localStorage.getItem(SEARCH_NAME) // 搜索

      if (param4) {
        return this.updateSelectedSearchGlobal([param4]);
      }

      if (param1 && param1.IsAllProducts) {
        return this.selectAllProducts();
      }

      if (param1) {
        let data = this.allGroups[0]
        if (isActivated && !data) {
          return setTimeout(() => {
            this.initializeSelection(false, isAllGroupsCategories)
          }, 2000)
        }
        data = this.allGroups.find(item => item.Name === param1.Name) || data
        if (!data) {
          this.isLoading = false;
          return;
        }
        return this.selectNewGroup(data).then(() => {
          if (!isAllGroupsCategories || !Array.isArray(param3) || !param3.length || !data) {
            return
          }
          setTimeout(() => {// 需要等selectNewGroup
            this.allGroups_Categories = data.Categories;
            this.allGroups_Categories_ids = param3;
            this.setLocalAllGroupsCategoriesIds();
            this.allGroupsCategoriesSelect(data, true)
          }, 2000)
        })
      }
      const param2 = JSON.parse(localStorage.getItem(SELECT_NEW_CUSTOM_CATEGORY))
      this.fetchProductsWithCustomCategoryId({id:'',company_id:this.companyId,warehouse_id:this.warehouseId})
        .then(res => {
          this.isLoading = false;
          const resData = responseList(res.data)
          if (!resData.length) {
            return
          }
          let data = resData[0]
          if (param2) {
            data = resData.find(item => item.Name === param2.Name) || data
          }
          const {Name, Description, ProductCategory2_id} = data
          this.selectedCustomCategoryLocal = [Name];
          this.navCustomCategory({
            Name,
            Description,
            ProductCategory2_id
          });
          this.selectNewCustomCategory(data)
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err', err);
        });
    },
    filterBillboard(billboard, language) {
      const filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      return filterBillboard;
    },
    refreshFilter() {
      localStorage.removeItem(SELECT_NEW_GROUP)
      localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY)
      localStorage.removeItem(ALL_GROUPS_CATEGORIES_SELECT)
      localStorage.removeItem(SEARCH_NAME)
      this.initializeSelection();
      this.updateSelectedGroupGlobal([]);
      this.updateSelectedCategoryGlobal([]);
      this.updateSelectedSearchGlobal([]);
      this.cleanPrice();
      this.cleanBrand();
      this.showMore = true;
      this.sortByFilter = '1';
    },
    adjustPriceSort() {
      this.list = this.savedList;

      const tempPrice = [];
      if (this.priceFilter && this.priceFilter < 51) {
        let sortedData = this.list.filter(item => item.Price <= this.priceFilter).map((a) => {
          tempPrice.push(a);
        });
        this.list = tempPrice;
      }

      const tempBrand = [];
      if (this.brandFilter && this.brandFilter.length > 0) {
        this.list.map(item => {
          this.brandFilter.map(brand => {
            if (item.Brand === brand) {
              tempBrand.push(item);
            }
          });
        });
        this.list = tempBrand;
      }

      if ((!this.brandFilter || this.brandFilter.length < 1) && (!this.priceFilter || this.priceFilter > 50)) {
        this.list = this.savedList;
      }

      let tempOut = [];
      let tempReg = [];
      let listOut = [];
      let listReg = [];
      if (this.list) {
        let sortOut = this.list.map((a) => {
          if (this.isOutOfStock(a)) {
            tempOut.push(a);
          } else {
            tempReg.push(a);
          }
        });
      }
      if (this.sortByFilter === '1') {
        // if (this.selectedCustomCategoryLocal[0]) {
        //   // '热门选项下的default的排序需要和首页一样，类别的default和原来一样'
        //   return this.list = this.reqProductsWithCustomCategoryData.reverse()
        // }
        listOut = tempOut.sort((a, b) => {
          return Number(a.GeneralNum) < Number(b.GeneralNum) ? 1 : -1;
        });
        listReg = tempReg.sort((a, b) => {
          return Number(a.GeneralNum) < Number(b.GeneralNum) ? 1 : -1;
        });
        // this.list = listReg.concat(listOut);
        this.list = listReg.concat(listOut).sort(function (itemA, itemB) {
          const refNumA = itemA.RefNum
          const refNumB = itemB.RefNum
          return refNumA.localeCompare(refNumB)
        })
      }
      if (this.sortByFilter === '2') {
        listOut = tempOut.sort((a, b) => {
          return Number(a.Name[0]) > Number(b.Name[0]) ? 1 : -1;
        });
        listReg = tempReg.sort((a, b) => {
          return Number(a.Name[0]) > Number(b.Name[0]) ? 1 : -1;
        });
        this.list = listReg.concat(listOut);
      }
      if (this.sortByFilter === '3') {
        listOut = tempOut.sort((a, b) => {
          return Number(a.Price) > Number(b.Price) ? 1 : -1;
        });
        listReg = tempReg.sort((a, b) => {
          return Number(a.Price) > Number(b.Price) ? 1 : -1;
        });
        this.list = listReg.concat(listOut);
      }
      //保留之前的所有的产品
      this.list2=JSON.parse(JSON.stringify(this.list));
      if (this.stockLevelChecked) {
        this.isSockLevelList(this.list);
      }
    },
    cleanPrice() {
      this.priceFilter = 51;
      this.priceOpen = true;
      this.adjustPriceSort();
    },
    cleanBrand() {
      this.brandFilter = [];
      this.brandOpen = true;
      if (this.searchBrand) {
        this.brandFilter = [this.searchBrand];
        this.brandOpen = true;
        this.searchBrand = '';
      }
      this.adjustPriceSort();
    },
    toggleCustomCategories() {
      this.customCategoriesOpen = !this.customCategoriesOpen;
    },
    toggleGroups() {
      this.groupsOpen = !this.groupsOpen
    },
    toggleSort() {
      this.sortOpen = !this.sortOpen
    },
    handleMobileSortChange(value) {
      this.sortByFilter = value
      this.adjustPriceSort()
      this.showppoducts = false
    },
    handleMobileStockChange() {
      this.isSockLevel()
      this.showppoducts = false
    },
    async toggleDesktopGroup(group) {
      const groupName = group.Name
      const shouldCollapse = this.desktopExpandedGroups.includes(groupName)

      // 点击一级分类时始终加载该分类的全部商品。
      await this.selectNewGroup(group, null, true)

      // 商品切换与菜单展开状态相互独立，保留手风琴的展开/收起行为。
      this.$nextTick(() => {
        this.desktopExpandedGroups = shouldCollapse ? [] : [groupName]
      })
    },
    togglePrice() {
      this.priceOpen = !this.priceOpen;
    },
    toggleBrand() {
      this.brandOpen = !this.brandOpen;
    },
    async printProducts() {
      if (this.isPrinting) return;
      if (this.isLoading || !this.productExportRequest) {
        return this.$message.warning(this.curIsEnglish ? 'Please wait for the product list to load.' : '请等待商品列表加载完成。');
      }
      this.closePrintPreview();
      const request = {};
      this._pdfPrintRequest = request;
      this.isPrinting = true;
      const showError = () => {
        if (this._pdfPrintRequest !== request) return;
        this.closePrintPreview();
        this.$message.error(this.curIsEnglish ? 'PDF print preview failed. Please try again.' : 'PDF 打印预览失败，请重试。');
      };
      try {
        const pdf = await exportFile(this.productExportRequest.type, 'pdf', this.productExportRequest.params);
        if (this._pdfPrintRequest !== request) return;
        this._pdfPrintCleanup = printPdf(pdf, () => {
          if (this._pdfPrintRequest === request) this.isPrinting = false;
        }, showError);
      } catch (err) {
        showError();
      }
    },
    closePrintPreview() {
      this._pdfPrintRequest = null;
      this.isPrinting = false;
      if (this._pdfPrintCleanup) {
        this._pdfPrintCleanup();
        this._pdfPrintCleanup = null;
      }
    },
    async exportProducts() {
      if (this.isLoading || this.isExporting || !this.productExportRequest || !this.exportableProducts.length) return;
      this.isExporting = true;
      try {
        await exportFile(this.productExportRequest.type, 'excel', this.productExportRequest.params);
      } catch (err) {
        
      } finally {
        this.isExporting = false;
      }
    },
    refreshProductsForWarehouse() {
      if (this.selectedSearchGlobal.length) {
        return this.navSearch(this.selectedSearchGlobal[0]);
      }
      if (this.allGroups_Categories_ids.length && !this.selectedCustomCategoryGlobal.length) {
        return this.fetchSelectedCategories(this.allGroups_Categories_ids.join(','));
      }
      if (this.selectedGroupGlobal.length) {
        const groups = this.allGroups.filter(group => this.selectedGroupGlobal.includes(group.Name));
        return this.navGroup(groups.length === 1 ? groups[0] : groups);
      }
      if (this.selectedCustomCategoryGlobal.length) {
        const categories = this.customCategories.filter(category => this.selectedCustomCategoryGlobal.includes(category.Name));
        if (categories.length) {
          return this.navCustomCategory(categories[0], categories, categories.length > 1);
        }
      }
      if (this.isAllProductsSelected) {
        return this.fetchProductWithSearchTerm('');
      }
      return this.initializeSelection();
    },
    selectAllProducts() {
      this.isAllProductsSelected = true;
      localStorage.setItem(SELECT_NEW_GROUP, JSON.stringify({IsAllProducts: true}));
      localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY);
      localStorage.removeItem(SEARCH_NAME);
      this.updateSelectedGroupGlobal([]);
      this.selectedGroupLocal = [];
      this.selectedCustomCategoryLocal = [];
      this.desktopExpandedGroups = [];
      this.allGroups_Categories = [];
      this.allGroups_Categories_id = null;
      this.allGroups_Categories_ids = [];
      this.setLocalAllGroupsCategoriesIds();
      this.activeGroupEn = 'All Products';
      this.activeGroupCh = '全部';
      this.activeCategoryEn = '';
      this.activeCategoryCh = '';
      this.searchType = '';
      this.searchBrand = '';
      this.changeNavGoId(null);
      this.changeShowProductsType1(null);
      this.changeShowProductsType2(null);
      this.changeShowProductsType3(null);
      this.changeSelectAfter(false);
      return this.fetchProductWithSearchTerm('');
    },
    async selectNewGroup(item, text, keepScrollPosition = false) {
      //保存id
      this.changeNavGoId(item);
      
      if(!text){
        //保存显示产品的类型
        this.changeShowProductsType1(null);
        this.changeShowProductsType2(null);
        this.changeShowProductsType3('group');
      }
      //类型数据中有数组
      if(Array.isArray(item)){
        let nameArray=[];
        let categoriesArray=[];
        item.forEach(item2 => {
          nameArray.push(item2.Name);
          categoriesArray.push(item2.Categories);
        })
        localStorage.setItem(SELECT_NEW_GROUP, JSON.stringify(item));
        localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY);
        localStorage.removeItem(SEARCH_NAME);
        this.updateSelectedGroupGlobal(nameArray);
        this.allGroups_Categories_id = null
        this.allGroups_Categories = categoriesArray;
        this.allGroups_Categories_ids = [];
        this.setLocalAllGroupsCategoriesIds();
        this.changeSelectAfter(!keepScrollPosition)
        let index=-1;
        nameArray.forEach(name => {
          this.allGroups.forEach((group,i) => {
            if(name === group.Name){
              index = i;
            }
          })
        })
        !keepScrollPosition && index > -1 && this.scrollToDom('allGroups'+index)
      }else{
        localStorage.setItem(SELECT_NEW_GROUP, JSON.stringify(item));
        localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY);
        localStorage.removeItem(SEARCH_NAME);
        this.updateSelectedGroupGlobal([item.Name]);
        this.allGroups_Categories_id = null
        this.allGroups_Categories = item.Categories;
        this.allGroups_Categories_ids = [];
        this.setLocalAllGroupsCategoriesIds();
        this.changeSelectAfter(!keepScrollPosition)
        const index = this.allGroups.findIndex(it => it.Name === item.Name)
        !keepScrollPosition && index > -1 && this.scrollToDom('allGroups'+index)
      }
      return true
    },
    navGroup(item) {
      this.isAllProductsSelected = false;
      if(Array.isArray(item)){
        let flag=false;
        let idArray=[];
        item.forEach(data => {
          if(data.Name == 'Beauty & Health & Home'){
            this.activeGroupEn = 'Beauty & Health & Home';
            this.activeGroupCh = 'Beauty & Health & Home';
            flag=true;
          }
          idArray.push(data.ProductGroup_id);
        })
        if(!flag){
          this.activeGroupEn = 'ALL Groceries';
          this.activeGroupCh = 'ALL Groceries';
        }
        this.activeCategoryEn = '';
        this.activeCategoryCh = '';
        this.fetchSelectedGroup(idArray);
        // this.fetchBrandOptions('group', idArray);
      }else{
        this.activeGroupEn = item.Name;
        this.activeGroupCh = item.Description;
        this.activeCategoryEn = '';
        this.activeCategoryCh = '';
        this.fetchSelectedGroup(item.ProductGroup_id);
        // this.fetchBrandOptions('group', item.ProductGroup_id);
      }
    },
    selectNewCustomCategory(item, index, isAdd) {
      const itemName = item.Name
      localStorage.setItem(SELECT_NEW_CUSTOM_CATEGORY, JSON.stringify(item));
      localStorage.removeItem(SELECT_NEW_GROUP);
      localStorage.removeItem(ALL_GROUPS_CATEGORIES_SELECT)
      localStorage.removeItem(SEARCH_NAME)
      const arr = []
      const selectedCustomCategoryGlobal = JSON.parse(JSON.stringify(this.selectedCustomCategoryGlobal))
      if (isAdd) {
        arr.push(...selectedCustomCategoryGlobal)
        const arrIdx = arr.indexOf(itemName)
        if (arrIdx < 0) {
          arr.push(itemName)
        } else {
          arr.splice(arrIdx, 1)
        }
      } else {
        arr.push(itemName)
      }
      this.updateSelectedCustomCategoryGlobal(arr);
      this.changeSelectAfter()
      if (!isAdd) {
        const idx = this.customCategories.findIndex(it => it.Name === itemName)
        idx > -1 && this.scrollToDom(`hot-`+idx)
      }
    },
    navCustomCategory(item, itemList, isMultiple) {
      this.isAllProductsSelected = false;
      if (isMultiple) {
        item = itemList[0]
      }
      this.activeGroupEn = item.Name;
      if (item.IsButton) {
        this.activeGroupCh = item.Name;
      } else {
        this.activeGroupCh = item.Description;
      }
      this.activeCategoryEn = '';
      this.activeCategoryCh = '';

      let ids = item.ProductCategory2_id
      if (isMultiple) {
        ids = itemList.map(item => item.ProductCategory2_id).join(',')
      }
      this.fetchSelectedCustomCategory(ids);
      this.fetchBrandOptions('category2', ids);
    },
    selectNewCategory(item, keepScrollPosition = false) {
      this.curSelectNewCategoryItem = item
      this.updateSelectedCategoryGlobal([item.Name]);
      this.changeSelectAfter(!keepScrollPosition)
    },
    navCategory(item, parent) {
      this.isAllProductsSelected = false;
      this.activeGroupEn = parent.Name;
      this.activeGroupCh = parent.Description;
      this.activeCategoryEn = item.Name;
      this.activeCategoryCh = item.Description;

      this.selectedGroupLocal = [parent.Name];
      this.desktopExpandedGroups = [parent.Name];
      this.allGroups_Categories = parent.Categories;
      this.allGroups_Categories_ids = [item.ProductCategory_id];
      this.setLocalAllGroupsCategoriesIds();

      this.fetchSelectedCategories([item.ProductCategory_id]);
      this.fetchBrandOptions('category', item.ProductCategory_id);
    },
    selectNewSearch(item, type) {
      this.searchType = type;
      if (type === 'Brand') {
        this.searchBrand = item;
      } else {
        this.searchBrand = '';
        localStorage.setItem(SEARCH_NAME, item)
      }
      if (item) {
        this.updateSelectedSearchGlobal([item]);
      } else {
        this.initializeSelection();
      }
      this.changeSelectAfter()
    },
    navSearch(item) {
      this.isAllProductsSelected = false;
      this.activeGroupEn = item;
      this.activeGroupCh = item;
      this.activeCategoryEn = '';
      this.activeCategoryCh = '';
      this.fetchProductWithSearchTerm(item);
      // this.fetchBrandOptions('search', item);
    },

    formatToolTip(val) {
      if (this.priceFilter !== 51) {
        this.priceFilterDisplay = '< $' + this.priceFilter;
        return '$' + val;
      } else {
        this.priceFilterDisplay = '';
        return 'All';
      }
    },
    fetchBrandOptions(type, id) {
      this.brandFilterOptions = [];
      this.fetchBrands({type, id})
        .then(res => {
          this.brandFilterOptions = res.data;
        }).catch(err => {
        console.log('err brand', err);
      })
    },
    async fetchProductWithSearchTerm(product) {
      this.productExportRequest = null;
      this.showMore = true;
      this.savedList = [];
      this.list = [];
      this.isLoading = true;
      let url = ``;
      if (this.searchType === 'Brand') {
        url = '?Brand=' + encodeURIComponent(product);
      } else {
        url = '?Name=' + encodeURIComponent(product);
      }
      const data = {
        company_id: this.companyId,
        warehouse_id: this.warehouseId
      };
      const exportRequest = {type: 'product', params: {...data, [this.searchType === 'Brand' ? 'Brand' : 'Name']: product}};
      await this.fetchProducts({name:url,company_id:data.company_id,warehouse_id:data.warehouse_id})
        .then(res => {
          this.productExportRequest = exportRequest;
          this.brandFilterOptions = res.data.brands || res.data.Brands || [];
          this.isLoading = false;
          const temp1 = [];
          const temp2 = [];
          let sortedData = [];
          sortedData = responseList(res.data, 'Products').map((a) => {
            a['ThumbnailLarge'] = a.Thumbnail;
            if (this.isOutOfStock(a)) {
              temp2.push(a)
            } else {
              temp1.push(a)
            }
          });
          this.listOut = temp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.listReg = temp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.savedList = this.listReg.concat(this.listOut);
          this.list = this.listReg.concat(this.listOut);
          this.adjustPriceSort();
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err search', err);
        })
    },
    async fetchSelectedCategories(id) {
      this.productExportRequest = null;
      this.showMore = true;
      this.list = [];
      this.isLoading = true;
      const data = {
        company_id: this.companyId,
        warehouse_id: this.warehouseId
      };
      const exportRequest = {type: 'category', params: {...data, id}};
      await this.fetchCategories({id,company_id:data.company_id,warehouse_id:data.warehouse_id})
        .then(res => {
          this.productExportRequest = exportRequest;
          this.isLoading = false;
          const ctemp1 = [];
          const ctemp2 = [];
          let sortedData = [];
          // if (this.priceFilter) {
          //   sortedData = res.data.filter(item => item.Price <= this.priceFilter).map((a)=>{
          //     if(this.isOutOfStock(a)) {
          //       ctemp2.push(a)
          //     }else {
          //       ctemp1.push(a)
          //     }
          //   });
          // } else {
          sortedData = responseList(res.data, 'Products').map((a) => {
            if (this.isOutOfStock(a)) {
              ctemp2.push(a);
            } else {
              ctemp1.push(a);
            }
          });
          // }
          this.catOut = ctemp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.catReg = ctemp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.savedList = this.catReg.concat(this.catOut);
          this.list = this.catReg.concat(this.catOut);
          this.adjustPriceSort();
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err fetching product', err);
        })
    },
    fetchSelectedCustomCategory(id) {
      this.productExportRequest = null;
      this.showMore = true;
      this.savedList = [];
      this.list = [];
      this.isLoading = true;
      const exportRequest = {type: 'category2', params: {id, company_id: this.companyId, warehouse_id: this.warehouseId, IsListView: true, nested: false}};
      this.fetchProductsWithCustomCategoryId({id,company_id:this.companyId,warehouse_id:this.warehouseId})
        .then(res => {
          this.productExportRequest = exportRequest;
          this.reqProductsWithCustomCategoryData = res.data
          this.isLoading = false;
          const temp1 = [];
          const temp2 = [];
          let sortedData = [];
          sortedData = responseList(res.data, 'Products').map((a) => {
            a['ThumbnailLarge'] = a.Thumbnail;
            if (this.isOutOfStock(a)) {
              temp2.push(a);
            } else {
              temp1.push(a);
            }
          });
          // }
          this.listOut = temp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.listReg = temp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.savedList = this.listReg.concat(this.listOut);
          this.list = this.listReg.concat(this.listOut);
          this.adjustPriceSort();
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err', err);
        });
    },
    fetchSelectedGroup(id) {
      this.productExportRequest = null;
      // this.currentGroupId = id;
      this.showMore = true;
      this.savedList = [];
      this.list = [];
      this.isLoading = true;
      this.fetchProductsWithGroupAll().then(resOut => {
        const groups = responseList(resOut.data);
        this.currentGroupCategories = [];
        if(Array.isArray(id)){
          let categoriesArray=[];
          let ids=[];
          id.forEach(data => {
            groups.map(r => {
              if (r.ProductGroup_id === data) {
                categoriesArray.push(...(r.Categories || []));
                ids.push(data);
              }
            });
          })
          this.currentGroupCategories = categoriesArray;
          id=ids.join();
        }else{
          groups.map(r => {
            if (r.ProductGroup_id === id) {
              this.currentGroupCategories = r.Categories || [];
            }
          });
        }
        const exportRequest = {type: 'group', params: {id, company_id: this.companyId, warehouse_id: this.warehouseId}};
        this.fetchProductsWithGroupId({id,company_id:this.companyId,warehouse_id:this.warehouseId})
          .then(res => {
            this.productExportRequest = exportRequest;
            this.isLoading = false;
            const temp1 = [];
            const temp2 = [];
            let sortedData = [];
            const products = responseList(res.data, 'Products');
            products.map((r, i) => {
              this.currentGroupCategories.map((r2, j) => {
                if (r.ProductCategory1_id === r2.ProductCategory_id) {
                  products[i].GeneralNum = (99 - j).toString() + products[i].GeneralNum;
                }
              })
            })
            sortedData = products.map((a) => {
              if (this.isOutOfStock(a)) {
                temp2.push(a);
              } else {
                temp1.push(a);
              }
            });
            // }
            this.listOut = temp2.sort((a, b) => {
              return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
            });
            this.listReg = temp1.sort((a, b) => {
              return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
            });
            this.savedList = this.listReg.concat(this.listOut);
            this.list = this.listReg.concat(this.listOut);
            this.adjustPriceSort();
          })
          .catch(err => {
            this.isLoading = false;
            console.log('err', err);
          });

      }).catch(err => {
        this.isLoading = false;
        console.log('error', err);
      });
    },
    filterGroups(filter) {
      let list = this.list.slice();
      let sortedList = [];
      if (filter === 'sale') {
        sortedList = list.sort((a, b) => {
          return a.IsPromotion ? 1 : -1;
        })
      }
      if (filter === 'low') {
        sortedList = list.sort((a, b) => {
          return a.Price > b.Price ? 1 : -1;
        })
      }
      if (filter === 'high') {
        sortedList = list.sort((a, b) => {
          return a.Price < b.Price ? 1 : -1;
        })
      }
      this.list = sortedList
    },
    throttleAddToCart: _.debounce(function (item, e) {
      e.preventDefault();
      busUtil.$emit('addToCartDrop', e, item)
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function (item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/getCart');
          }
        });
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    goToHome() {
      this.$router.push(`/home`);
    },
    clickShowMore() {
      this.pageInfo.pageNum++
    },
    showMoreRecommend() {
      this.isLoading = true;
      this.fetchProductsWithCustomCategoryId({id:'',company_id:this.companyId,warehouse_id:this.warehouseId})
        .then(res => {
          this.isLoading = false;
          const resData = responseList(res.data);
          if (!resData) {
            return
          }
          const length = resData.length
          if (!length) {
            return;
          }
          const {Name, Description, ProductCategory2_id} = resData[length - 1]
          this.selectedCustomCategoryLocal = [Name];
          this.navCustomCategory({
            Name: Name,
            Description: Description,
            ProductCategory2_id: ProductCategory2_id
          });
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err', err);
        });
      this.changeDocumentScrollTop()
    },
    switchView(view) {
      this.currentView = view;
    },
    getStarIndex(rating) {
      let temp = [];
      if (rating || rating === 0) {
        for (let i = 1; i < 6; i++) {
          if (rating >= i) {
            temp.push(star2);
          } else if (rating > (i - 1) && rating < i) {
            temp.push(star1);
          } else if (rating <= (i - 1)) {
            temp.push(star0);
          }
        }
      } else {
        temp = [star0, star0, star0, star0, star0];
      }
      return temp;
    },
    checkViewableLanguages(data, lang) {
      for (let i = 0; i < data.split(',').length; i++) {
        if (data.split(',')[i] === lang) {
          return true;
        }
      }
      return false;
    },
    onClickBillboard(url, type) {
      if (type === "URL") {
        window.location.href = url;
      } else if (type === "Category2") {
        this.selectNewCustomCategory({Name: url});
        this.changeDocumentScrollTop()
      } else if (type === "Group") {
        this.selectNewGroup({Name: url});
        this.changeDocumentScrollTop()
      } else if (type === "Category") {
        this.selectNewCategory({Name: url});
        this.changeDocumentScrollTop()
      } else {

      }
    },

    // ----- -- -- -- - ------ -- -----
    searchProduct() {
      //保存显示产品的类型
      this.changeShowProductsType1(null);
      this.changeShowProductsType2('search');
      this.changeShowProductsType3(null);
      if (this.$router.currentRoute.path !== '/collections') {
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewSearch(this.searchTerm, 'Name');
        }, 600);
      } else {
        this.$root.selectNewSearch(this.searchTerm, 'Name');
      }
    },
    // 滚动到指定DOM
    scrollToDom(ref) {
      this.$nextTick(() => {
        const refC = this.$refs[ref]
        if (!refC) {
          return console.log(refC)
        }
        const comC = refC[0]
        comC && comC.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      })
    },
    // 格式化显示
    formatCustomCategoriesCheckbox(item) {
      const {Name, Description, ViewableLanguages, IsButton} = item
      if (this.curIsEnglish && this.checkViewableLanguages(ViewableLanguages, 'EN')) {
        return Name
      }
      if (this.curIsChinese && this.checkViewableLanguages(ViewableLanguages, 'ZH')) {
        return !IsButton ? Description : Name
      }
      return ''
    },
    // 滚动页面的滚动条
    changeDocumentScrollTop() {
      //距离网页顶部的距离
      document.documentElement.scrollTop = 700
    },
    changeSelectAfter(shouldScroll = true) {
      if (shouldScroll) {
        this.changeDocumentScrollTop();
      }
      this.cleanPrice();
      this.cleanBrand();
    },
    setLocalAllGroupsCategoriesIds() {
      localStorage.setItem(ALL_GROUPS_CATEGORIES_SELECT, JSON.stringify(this.allGroups_Categories_ids));
    },
    bannerSwiperMouseenter() {
      const bannerSwiperCom = this.$refs.bannerSwiperRef
      if (!bannerSwiperCom) {
        return
      }
      bannerSwiperCom.swiper.autoplay.stop()
    },
    bannerSwiperMouseleave() {
      const bannerSwiperCom = this.$refs.bannerSwiperRef
      if (!bannerSwiperCom) {
        return
      }
      bannerSwiperCom.swiper.autoplay.start()
    },
    handleQueryParams() {
      // type=1 为分类
      // type=2 为category2
      // type=3 为搜索

      const {name, type} = this.$route.query
      let key = ''
      switch (Number(type)) {
        case 1: key = SELECT_NEW_GROUP
          break;
        case 2: key = SELECT_NEW_CUSTOM_CATEGORY
          break;
        case 3: key = SEARCH_NAME
          break;
        default: key = SELECT_NEW_GROUP
      }
      if (name) {
        localStorage.removeItem(SELECT_NEW_GROUP);
        localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY);
        localStorage.removeItem(SEARCH_NAME);
        const str = decodeURIComponent(name);
        let val = JSON.stringify({Name: str});
        if (Number(type) === 3) {// 搜索特殊处理
          val = str;
        }
        localStorage.setItem(key, val);
        if (!this.isApp) {
          setTimeout(() => {
            const {fullPath, query} = this.$route;
            const params = JSON.stringify({fullPath, query});
            const UniversalLink = this.isIosWeb ? this.openAppInfo.UniversalLink : this.openAppInfo.urlSchemes;
            window.location = `${UniversalLink}?type=email_click_product&params=${encodeURIComponent(params)}`;
          }, 3000)
        }

      }
    },
    setIsFixedByScrollNumber(event) {
      const val = event.target.scrollTop > 250
      if (this.isFixed === val) return
      this.isFixed = val
    },
    resetProductListScroll() {
      this.$nextTick(() => {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0

        const el = document.getElementById('product-list-container-id')
        if (el) el.scrollTop = 0
      })
    },
    initElScrollHandle() {
      this.isFixed = false
      const el = document.getElementById('product-list-container-id')
      el.addEventListener('scroll', this.setIsFixedByScrollNumber)
    },
    removeElScrollHandle() {
      const el = document.getElementById('product-list-container-id')
      el && el.removeEventListener('scroll', this.setIsFixedByScrollNumber)
    },
    getSelectItemName(selectItem, newVal0LowerCaseStr) {
      let selectItemName = undefined;
      if (selectItem && typeof selectItem.Name === "string") {
        selectItemName = selectItem.Name.toLowerCase();
      }
      if (selectItemName && selectItemName === newVal0LowerCaseStr) {
        // 名字对不上，清除
        this.curSelectNewCategoryItem = null;
        return selectItemName
      }
      return undefined
    },
    // 显示所有的商品
    showAllProduct() {
      // 默认不分页的话，不再出现分页
      if (!defaultIsPage) return
      this.isPage = false;
    },
    // 显示分页后需要显示的商品
    showPageProduct() {
      // 默认不分页的话，不再出现分页
      if (!defaultIsPage) return
      this.isPage = true;
    },
    imgLoad() {
    },
    imgAbort() {
    },
    //是否显示有库存的方法
    isSockLevel(){
      this.isLoading = true;
      //显示有库存的产品
      if(this.stockLevelChecked){
        //显示有库存的产品
        this.isSockLevelList(this.list);
      }else{
        //显示所有的产品
        this.list=JSON.parse(JSON.stringify(this.list2));
      }
      //加载中
      setTimeout(()=>{
        this.isLoading = false;
      },1000)
    },
    //默认显示有库存的产品
    isSockLevelList(list){
      const isSockLevelArr=[];
      list.forEach(item => {
        //有库存的产品
        if(item.InventoryQuantity>0){
          isSockLevelArr.push(item);
        }
      })
      
      this.list=JSON.parse(JSON.stringify(isSockLevelArr));
    },
    //点击商品图片
    clickZoom(images){
      if(images){
        //显示商品图片的弹窗
        this.imagesVisible=true;
        this.images=images;
      }
    },
    closeImages(){
      this.imagesVisible=false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
        .then(() => {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
            })
        })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: {
    exportableProducts() {
      return this.list.filter(item => !item.IsStopSale);
    },
    ...mapState({
      allGroups: state => state.navbar.allGroups,
      activeProduct: state => state.products.activeProduct,
      product: state => state.products.productDetails[0],
      necessaryCartItems: state => state.cart.necessaryCartItems,
      itemCount: state => state.cart.itemCount,
      billboards: state => state.billboard.billboardImages,
      selectedGroupGlobal: state => state.products.selectedGroupGlobal,
      selectedCustomCategoryGlobal: state => state.products.selectedCustomCategoryGlobal,
      selectedCategoryGlobal: state => state.products.selectedCategoryGlobal,
      selectedSearchGlobal: state => state.products.selectedSearchGlobal,
      customCategories: state => state.products.customCategories,
      currentLang: state => state.navbar.currentLang,
      openAppInfo: state => state.openAppInfo,
      isAndroidWeb: state => state.isAndroidWeb,
      isIosWeb: state => state.isIosWeb,
      companyId: state => state.products.companyId,
      warehouseId: state => state.products.warehouseId,
      loggedIn: state => state.auth.loggedIn,
    }),
    showList({curShowListNum, isPage}) {
      // return this.list.sort(this.outOfStockToEnd)
      if (!isPage) {
        this.changeShowList(this.list);
        return this.list
      }
      this.changeShowList(this.list.slice(0, curShowListNum));
      return this.list.slice(0, curShowListNum)
    },
    // 当前展示的商品的样式是否是默认样式
    currentViewIsGallery() {
      return this.currentView === GALLERY
    },
    customButtonCategories() {
      return this.customCategories.filter(item => item.IsButton)
    },
    customENButtonCategories() {
      return this.customButtonCategories.filter(item => this.checkViewableLanguages(item.ViewableLanguages, 'EN'))
    },
    customZHButtonCategories() {
      return this.customButtonCategories.filter(item => this.checkViewableLanguages(item.ViewableLanguages, 'ZH'))
    },
    isShowHotLists() {
      return this.selectedCustomCategoryLocal[0]
    },
    isShowCategoryButtons() {
      return this.selectedGroupLocal[0]
    },
    isShowCategorySubclassButtons() {
      return this.selectedGroupLocal.length > 0
    },
    collectionsFixedHeight() {
      const {isShowHotLists, isShowCategoryButtons, isShowCategorySubclassButtons} = this
      if (isShowHotLists) return 208
      if (isShowCategoryButtons) {
        if (isShowCategorySubclassButtons) return 308
        return 260
      }
      return 168
    },
    isShowShowMoreContent({isLoading, pageInfo, curShowListNum, isPage}) {
      if (!isPage) return false
      const total = pageInfo.total
      return !isLoading && total && curShowListNum < total
    },
    curShowListNum({pageInfo}) {
      return pageInfo.pageNum * pageInfo.pageSize || pageInfo.pageSize
    }
  },
  watch: {
    currentLang: function (newVal) {
      const selectedCustomCategoryGlobal = JSON.parse(JSON.stringify(this.selectedCustomCategoryGlobal));
      const newValIsCh = newVal === 'ch'
      let listName = 'customZHButtonCategories'
      if (newValIsCh) {
        listName = 'customENButtonCategories'
      }
      const list = this[listName]
      if (!list || !Array.isArray(list) || !list.length) {
        return
      }
      list.forEach(buttonItem => {
        const idx = selectedCustomCategoryGlobal.findIndex(item => item.toLowerCase().replaceAll(' ') === buttonItem.Name.toLowerCase().replaceAll(' '))
        idx > -1 && selectedCustomCategoryGlobal.splice(idx, 1, buttonItem.Description)
      })
      this.updateSelectedCustomCategoryGlobal(selectedCustomCategoryGlobal);
    },
    selectedGroupGlobal: function (newVal, oldVal) {
      this.selectedGroupLocal = newVal;
      if (newVal !== oldVal) {
        if (newVal.length === 1) {
          this.desktopExpandedGroups = [newVal[0]];
        } else if (!this.selectedCategoryGlobal.length) {
          this.desktopExpandedGroups = [];
        }
      }
      if (newVal !== oldVal && newVal.length === 1) {
        const currentGroup = this.allGroups.filter(group => {
          return newVal[0].toLowerCase() === group.Name.toLowerCase();
        });
        this.navGroup(currentGroup[0]);
      }
      //如果数据是数组
      if (newVal !== oldVal && newVal.length > 1) {
        let currentGroup=[];
        newVal.forEach(name => {
          this.allGroups.forEach((group,i) => {
            if(name.toLowerCase() === group.Name.toLowerCase()){
              currentGroup.push(group);
            }
          })
        })
        this.navGroup(currentGroup);
      }
    },
    selectedCustomCategoryGlobal: function (newVal, oldVal) {
      this.selectedCustomCategoryLocal = newVal;
      const length = newVal.length
      const customCategories = this.customCategories
      if (newVal !== oldVal && length > 0 && customCategories.length) {
        const currentCustomCategory = customCategories.filter(customCategory => {
          const customCategoryName = customCategory.Name.toLowerCase();
          return newVal.find(name => name.toLowerCase() === customCategoryName)
        });
        if (length === 1) {
          return this.navCustomCategory(currentCustomCategory[0]);
        }
        // 选择了多个
        this.navCustomCategory({}, currentCustomCategory, true)
      }
    },
    selectedCategoryGlobal: function (newVal, oldVal) {
      let currentCategory = {};
      let parentGroup = {};
      if (newVal !== oldVal && newVal.length === 1) {
        const selectItem = this.curSelectNewCategoryItem
        const newVal0LowerCaseStr = newVal[0].toLowerCase()
        let selectProductCategory_id = ''
        const selectItemName = this.getSelectItemName(selectItem, newVal0LowerCaseStr)
        if (selectItemName && selectItem.ProductCategory_id) {
          selectProductCategory_id = selectItem.ProductCategory_id
        }

        this.allGroups.map(group => {
          group.Categories.find(cat => {
            // 有id判断下id，没有就只根据名字判断
            if (selectProductCategory_id && selectProductCategory_id !== cat.ProductCategory_id) {
              return false
            }
            if (newVal0LowerCaseStr === cat.Name.toLowerCase()) {
              parentGroup = group;
              currentCategory = cat;
              return true
            }
            return false
          });
        });
        this.navCategory(currentCategory, parentGroup);
      }
    },
    selectedSearchGlobal: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal.length === 1) {
        this.navSearch(newVal[0]);
      }
    },
    filter: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterGroups(newVal);
      }
    },
    selectedCustomCategoryLocal(newVal) {
      clearTimeout(window.afm_selectedCustomCategoryLocalTimeoutId);
      window.afm_selectedCustomCategoryLocalTimeoutId = setTimeout(() => {
        const resCustomCategories = this.customCategories.filter(item => newVal.includes(item.Name))
        if (!resCustomCategories.length) {
          return
        }
        const curIsChinese = this.curIsChinese
        let activeGroupEnList = []
        let activeGroupChList = []
        resCustomCategories.forEach(item => {
          const {Name, Description, IsButton} = item;
          if (IsButton && curIsChinese) {
            activeGroupEnList.push(Description);
            activeGroupChList.push(Name)
            return
          }
          activeGroupEnList.push(Name);
          activeGroupChList.push(Description)
        })
        this.activeGroupEn = activeGroupEnList.join(',');
        this.activeGroupCh = activeGroupChList.join('，');
      }, 500)
    },
    list: {
      immediate: true,
      handler(newVal, oldVal) {
        let total = 0
        if (Array.isArray(newVal)) {
          total = newVal.length
        }
        if (this.pageInfo.total === total) return
        this.pageInfo.total = total
      },
      deep: true,
    },
    isLoading: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return
        this.resetProductListScroll()
        this.showPageProduct()
        if (this.pageInfo.pageNum === 1) return
        this.pageInfo.pageNum = 1
      }
    }
  },
  mounted() {
    this.$store.dispatch('billboard/fetchBillboardImages');
    this.$store.dispatch('products/fetchCustomCategories',{company_id: this.companyId,warehouse_id: this.warehouseId});
    this.$store.dispatch('navbar/fetchGroups');
    // this.$store.dispatch('products/fetchProductsWithGroupId', '');
    // this.$root.fetchSelectedGroup = this.fetchSelectedGroup.bind(this);
    this.$root.refreshProductsForWarehouse = this.refreshProductsForWarehouse.bind(this);
    this.$root.selectAllProducts = this.selectAllProducts.bind(this);
    this.$root.selectNewGroup = this.selectNewGroup.bind(this);
    this.$root.selectNewCategory = this.selectNewCategory.bind(this);
    this.$root.selectNewCustomCategory = this.selectNewCustomCategory.bind(this);
    this.$root.selectNewSearch = this.selectNewSearch.bind(this);
    this.$root.showMoreRecommend = this.showMoreRecommend.bind(this);
    this.$root.showAllProduct = this.showAllProduct.bind(this);
    this.$root.showPageProduct = this.showPageProduct.bind(this);
    this.cleanPrice();
    this.cleanBrand();
    let that = this
    Utils.$on("clearList", async function () {
      that.isLoading = true
      that.list = []
    });
  },
  activated() {
    this.resetProductListScroll()
    this.initElScrollHandle()
    this.allGroups_Categories = [];
    this.selectedGroupLocal = []
    setTimeout(() => {
      this.handleQueryParams()
      if (this.selectedGroupGlobal.length < 1 && this.selectedCustomCategoryGlobal.length < 1 && this.selectedCategoryGlobal.length < 1 && this.selectedSearchGlobal.length < 1) {
        this.initializeSelection(true, true);
      }
    },2000)
  },
  beforeDestroy() {
    this.closePrintPreview();
  },
  deactivated() {
    this.closePrintPreview();
    this.removeElScrollHandle()
  }
}
</script>

<style lang="less">
@import (css) url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:wght@400;700&family=Do+Hyeon&family=Noto+Sans+SC:wght@400;500;600;700&display=swap');
@import "../assets/css/home.less";
@import "../assets/css/productListUse.less";
@import "../assets/css/public.less";

#product-list-container-id,
#product-list-container-id *:not([class^="el-icon-"]):not([class*=" el-icon-"]):not(.fa):not(.fas):not(.far):not(.refNum-name):not(.product-card-name) {
  // font-family: 'Atkinson Hyperlegible', sans-serif !important;
}

#product-list-container-id .product-card-name {
  font-family: 'Do Hyeon' !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  margin-bottom: 10px !important;
}

#product-list-container-id .breadcrumb-container .bread-text,
#product-list-container-id .breadcrumb-container .el-breadcrumb__separator,
#product-list-container-id .is-stockLevel .el-checkbox__label,
#product-list-container-id .sort-by-filter > span,
#product-list-container-id .sort-by-filter .afm-select-container input,
#product-list-container-id .sort-by-filter .option-item {
  font-family: 'Do Hyeon' !important;
  font-weight: 700 !important;
  font-size: 26px !important
}

.rotate-enter-active .rotate-leave-active {
  transform: rotate(0.5turn);
}

.rotate {
  transform: rotateZ(180deg);
  transition: all 0.5s ease-out;
}

.rotate-back {
  transform: rotateZ(0);
  transition: all 0.5s ease-out;
}

.MbproductList {
  .category-buttons {
    display: block !important;
    padding-top: 0;
    margin-bottom: 0;

    ul {
      flex-direction: unset;
      width: unset;
      justify-content: unset;
      align-items: unset;
      flex-wrap: unset;
      margin: unset;

      li {
        margin-right: 15px;
        flex-shrink: 0;
        text-align: center;
        font-size: 12px;
        width: 56px;
        padding-bottom: unset;

        .group-button-container {
          display: unset;
          flex-direction: unset;
          justify-content: unset;
          align-items: unset;
          margin-bottom: unset;

          .image-placeholder {
            background-color: unset;
            cursor: unset;

            box-shadow: 1px 3px 4px 2px rgba(0, 0, 0, 0.05);
            border-radius: 4px;
            overflow: hidden;
            width: 100%;
            height: 56px;
            display: flex;
            margin-bottom: 7px;
            border: 1px solid transparent;
            justify-content: center;
            align-items: center;

            .button-image {
              max-width: 90%;
              max-height: 90%;
            }
          }

          .image-placeholder.is-active {
            background: unset;
          }

          .group-button-name {
            font-size: unset;
            font-family: unset;
            font-weight: unset;
            color: inherit;
            padding-top: unset;
          }
        }
      }
    }
  }
  .hidden {
    display: none !important;
  }
  .category-subclass-buttons {
    background-color: #FFFFFF;
    transition: all 0.3s;
    z-index: 998;
  }
  .fixed_container {
    background-color: #131e1e;
    color: #FFFFFF;
    width: 100vw;
    //margin-left: -16px;
    transform: translateX(-16px);
    padding: 5px 0;
    position: fixed;
    top: 50px;

    .allGroups_Categories {
      li {
        &.active{
          color: #ffffff;
          border-radius: 0px;
          background-color: transparent;
          border-bottom: 3px solid #7cc26a;
        }
      }
    }
  }
}

@import "../assets/query/mobile-collections-refresh.less";
</style>



// WEBPACK FOOTER //
// src/view/productList.vue